const release = {
  commit: "03d2550fb0bd22af0a254cd57a3e8dfc841b32a6",
  version: "202501.72000.12",
};

export default release;
